import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, Loader, StatCard, EmptyState } from "@/components/ui-kit";
import { StatusBadge } from "@/components/StatusBadge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Construction, AlertTriangle, PackageSearch, Gauge, ListTodo, ShieldAlert, ClipboardX, FolderKanban } from "lucide-react";
import { ProgressBar } from "@/components/technique/TechSummary";

export default function TechDashboard() {
  const [d, setD] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/technique/dashboard").then((r) => setD(r.data)); }, []);
  if (!d) return <Loader />;
  const s = d.stats; const sup = d.supervisor; const m = sup ? "" : "Mes ";
  const cards = sup ? [
    ["Nombre de projets", s.total, FolderKanban, "blue"], ["Projets en cours", s.en_cours, Construction, "blue"],
    ["Projets en retard", s.projets_retard, AlertTriangle, "rose"], ["Tâches en retard", s.taches_retard, ListTodo, "rose"],
    ["Incidents ouverts", s.incidents_ouverts, ShieldAlert, "amber"], ["Demandes matériaux", s.demandes_attente, PackageSearch, "amber"],
    ["Réserves ouvertes", s.reserves_ouvertes, ClipboardX, "amber"], ["Avancement global", `${s.avancement_moyen} %`, Gauge, "emerald"],
  ] : [
    ["Mes projets", s.total, FolderKanban, "blue"], ["Mes tâches", s.taches, ListTodo, "blue"],
    ["Mes tâches en retard", s.taches_retard, AlertTriangle, "rose"], ["Mes incidents", s.incidents_ouverts, ShieldAlert, "amber"],
    ["Mes demandes", s.demandes_attente, PackageSearch, "amber"], ["Mes réserves", s.reserves_ouvertes, ClipboardX, "amber"],
    ["Avancement de mes projets", `${s.avancement_moyen} %`, Gauge, "emerald"],
  ];
  return (
    <div>
      <PageHeader title="Tableau de bord technique" subtitle={sup ? "Vue d'ensemble de tous les projets en exécution" : "Vos projets affectés"} />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-5" data-testid="tech-dash-stats">
        {cards.map(([label, value, icon, accent]) => <StatCard key={label} label={label} value={value} icon={icon} accent={accent} />)}
      </div>
      {d.files.length === 0 ? <EmptyState icon={Construction} title={`${m}Aucun dossier technique`} subtitle="Les projets apparaissent ici dès qu'un suivi technique est ouvert depuis Technique → Suivi technique." /> : (
        <div className="rounded-xl border bg-white overflow-hidden"><div className="overflow-x-auto scrollbar-thin">
          <Table>
            <TableHeader><TableRow className="bg-slate-50">
              <TableHead>Projet client</TableHead><TableHead>Client</TableHead><TableHead>Chantier</TableHead>
              <TableHead className="w-44">Avancement</TableHead><TableHead>Technicien</TableHead><TableHead>Retards</TableHead><TableHead>Statut</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {d.files.map((f) => (
                <TableRow key={f.id} data-testid={`tech-dash-row-${f.id}`} className="cursor-pointer hover:bg-slate-50" onClick={() => nav(`/technique/dossier/${f.id}`)}>
                  <TableCell className="font-semibold">{f.project_name}<span className="block font-mono text-[10px] text-slate-400">{f.numero}</span></TableCell>
                  <TableCell className="text-slate-600">{f.client_name || "—"}</TableCell>
                  <TableCell className="text-slate-600">{f.chantier_nom || "—"}</TableCell>
                  <TableCell><div className="flex items-center gap-2"><ProgressBar value={f.summary.avancement} /><span className="font-mono text-xs w-12 text-right">{f.summary.avancement} %</span></div></TableCell>
                  <TableCell className="text-slate-600">{f.technicien_name || "—"}</TableCell>
                  <TableCell className={f.summary.taches_retard ? "text-rose-600 font-bold" : "text-slate-400"}>{f.summary.taches_retard}</TableCell>
                  <TableCell><StatusBadge value={f.statut} /></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div></div>
      )}
    </div>
  );
}
